import React from 'react';
import { Modal, Divider, Button, Image, Label, Icon, Grid, Card, Checkbox, Message } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form, Dropdown } from 'formsy-semantic-ui-react';
import CommonTable from '../../drive/Table/TableLayoutWithoutLocalFilter';
// import CommonTable from '../../workspace/contentManager/DesignerPane/TableLayoutWithLocalFilter';
import tableHeader from '../Modal/publishContentJson.json'
import deleteTableHeader from '../Modal/deleteContentJson.json'
import LoadingComponent from '../../common/LoadingComponent';
import _ from 'lodash'
import { singleLineText } from '../../common/RegexValidation';
import setCategoryImage from '../../../helpers/setCategoryImage'
import { toastr } from 'react-redux-toastr';

class PublishAllContentModal extends React.Component {
    constructor(props) {

        super(props);
        this.state = {
            tableHeader: this.props.dataType === "deleteAll"? deleteTableHeader:tableHeader,
            content: props.selectedMultipleIds,
            params: {},
            markAll: [],
            _limit: this.props.user && this.props.user.preferences ? this.props.user.preferences.contentTableLimit : 10,
            _sort: 'createdAt',
            k: null,
            c: null,
            s: null,
            enabledOperation: false,
            showLoading: true, 
            totalRecords: null,
            //noRecordAvailable: props.contentListData.total === 0 ? true : false
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.contentListData !== this.props.contentListData) {
            if (this.props.contentListData && this.props.contentListData.total) {
                this.setState({
                    totalRecords: this.props.contentListData.total,
                });
            }
        }
    }
    handleClose = async (e) => {

        this.props.handlePublishAllModal(false);
        this.setState({
            params: {},
            markAll: [],
            content: [],
            k: null,
            c: null,
            s: null,
            enabledOperation: false,
            totalRecords:null
        })
        await dispatch.content.setMultipleIds([])
    }

    setAllBasecategory(data) {
        const tableHead = [...this.state.tableHeader];
        //  User List
        let user = [];
        if (this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.length !== 0) {

            for (let i = 0; i < this.props.selectedAccount.users.length; i++) {
                let ia = this.props.selectedAccount.users[i]
                if(ia.id){
                    user.push({
                        value: ia.id._id,
                        text: ia.id.firstName + ' ' + ia.id.lastName,
                        content: (
                            <span>
                                <Image key={i} avatar className="w_24 h_24 scaleDown" src={ia.id.profilePic} />
                                {ia.id.firstName}  {ia.id.lastName}
                            </span>
                        ),
                    })
                }
            }
        }

        //  Selected Knowledge Bank , category , subcategory 
        let baseId = ""
        let catId = ""
        let subId = ""

        if (data && data.$and) {
            _.map(data.$and, k => {

                if (k.baseCategory) {
                    baseId = k.baseCategory
                }
                if (k.category) {
                    catId = k.category
                }
                if (k.subCategory) {
                    subId = k.subCategory
                }
            })
        }

        // Knowledge Bank 
        let basecategory = this.props.categoryList


        // Category
        let category = [];
        if (baseId !== "") {
            category = basecategory && basecategory.filter(f => { return f._id === baseId })[0].nodes;
        }
        else if (baseId === "") {
            let setNodes = [];
            _.map(basecategory, k => { return k.nodes && setNodes.push(k.nodes) })
            category = setNodes.flat()
            setNodes = []
        }
        // subcategory
        let subcategory = [];
        if (catId !== "") {
            subcategory = category && category.filter(f => { return f._id === catId })[0].nodes;
        }
        else if (catId === "") {
            let setNodes = []
            _.map(category, k => { return k.nodes && setNodes.push(k.nodes) })
            subcategory = setNodes.flat()
        }

        //Disable Conditions for different senario
        let allEmpty = baseId === "" && catId === "" && subId === ""
        let dBase = !allEmpty && ((baseId === "" && catId === "" && subId !== "") || (baseId === "" && catId !== "" && subId === "") || catId !== "" || (basecategory && basecategory.length === 0))
        let dCat = !allEmpty && ((baseId === "" && catId === "" && subId !== "") || subId !== "" || (category && category.length === 0));
        let dSubCat = !allEmpty && ((baseId === "" && catId === "" && subId === "") || (baseId !== "" && catId === "") || (subcategory && subcategory.length === 0));


        tableHead[3].keyValue = basecategory.map(m => { return { text: m.name, value: m._id } });
        tableHead[3].disabled = dBase;

        tableHead[4].keyValue = category && category.map(m => { return { text: m.name, value: m._id } });
        tableHead[4].disabled = dCat

        tableHead[5].keyValue = subcategory && subcategory.map(m => { return { text: m.name, value: m._id } });
        tableHead[5].disabled = dSubCat

        tableHead[6].keyValue = user;
        if (this.props.dataType !== "updateCategory" && this.props.dataType !== "deleteAll") {
            tableHead[7].listed = false
        } else {
            tableHead[7].listed = true
        }
        this.setState({ tableHeader: tableHead });
    }




    handleCancle = (e) => {
        this.handleClose();
    }

    enableBulkOperation = async (e, data) => {
        this.setState({ enabledOperation: data.checked })
    }

    handleSubmit = async (e, data) => {

        let payload = {
            dataType: data.dataType,
            baseCategory: this.state.k,
            category: this.state.c,
            subCategory: this.state.s,
            idArray: _.map(this.state.content, "_id")
        }

        if (this.props.dataType === "deleteAll") {
            try {
                let message = <div className="confirmMessage">
                    <h3>Delete Content</h3>
                    <label>{payload.name}</label>
                    <p>Are you sure that you wish to do this?</p>
                    <span >This action is not reversible</span>
                </div>
                toastr.confirm(message, {
                    onOk: async () => {
                        
                        this.setState({showLoading:true})
                          dispatch.content.deleteBulkContent(payload);
                         this.handleClose();                        
                         dispatch.content.getContentsCount({ organizationId: this.props.selectedOrganisation.id })
                        this.setState({showLoading:false})
                    }
                });
            }
            catch (err) {
                const toastrConfirmOptions = {
                    disableCancel: true
                };
                toastr.confirm(err.message, toastrConfirmOptions, {
                    onOk: () => {
                    }
                });
            }
        } else {            
            if (this.props.dataType === "updateCategory") {
                let repeatedCategoryContent;
                if(this.props.contentListData && this.state.totalRecords && this.state.content && this.state.content.length > 0 && this.props.contentListData.total > 0 && this.state.content.length === this.state.totalRecords){
                    repeatedCategoryContent = this.state.content.filter(cont=> cont.baseCategory === this.state.k && cont.category === this.state.c && cont.subCategory === this.state.s );
                }else {
                    let kb = this.state.privateCategory.find(pt => pt._id === this.state.k);
                    let cat = this.state.KBCategories.find(kbcat => kbcat._id === this.state.c);
                    let subCat = this.state.KBSubCategories.find(kbSub => kbSub._id === this.state.s);
                    repeatedCategoryContent = this.state.content.filter(cont=> cont.baseCategory === kb.name && cont.category === cat.name && cont.subCategory === subCat.name );
                }
                if(repeatedCategoryContent && repeatedCategoryContent.length > 0){
                    try {
                        let message = <div className="confirmMessage" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <h3>Confirm Update Content</h3>
                            <label>{payload.name}</label>
                            <p>Below Content(s) are already associated with same category</p>
                            <ul> 
                                {repeatedCategoryContent.map(content => (
                                    <li key={content._id}>{content.name}</li>
                                ))}
                            </ul>
                            <span>To skip content(s) press skip or press cancel to change the category</span>
                        </div>
                        toastr.confirm(message, {
                            okText: 'Skip',
                            onOk: async () => {
                                payload.idArray = payload.idArray.filter(id => {
                                    return !repeatedCategoryContent.some(content => content._id === id);
                                });
                                repeatedCategoryContent = repeatedCategoryContent.filter(content => payload.idArray.includes(content._id));
                                this.setState({content:repeatedCategoryContent});
                                if(payload.idArray.length > 0) {
                                    this.setState({showLoading:true})
                                    await dispatch.content.publishedBulkContent(payload);
                                    this.handleClose();
                                    dispatch.content.getContentsCount({ organizationId: this.props.selectedOrganisation.id })
                                    this.setState({showLoading:false})
                                } else {
                                    this.handleClose();
                                    dispatch.content.getContentsCount({ organizationId: this.props.selectedOrganisation.id })
                                }
                            }
                        });
                    }
                    catch (err) {
                        const toastrConfirmOptions = {
                            disableCancel: true
                        };
                        toastr.confirm(err.message, toastrConfirmOptions, {
                            onOk: () => {
                            }
                        });
                    }
                } else {
                    await dispatch.content.publishedBulkContent(payload);
                    this.handleClose();
                    dispatch.content.getContentsCount({ organizationId: this.props.selectedOrganisation.id })    
                }
            } else {
            await dispatch.content.publishedBulkContent(payload);
            this.handleClose();
            dispatch.content.getContentsCount({ organizationId: this.props.selectedOrganisation.id })    
            }
        }
        }

    onQueryChange = async (query, q) => {

        if (!(query.$and && this.state.query.$and && query.$and.every(q=>this.state.query.$and.some(s=>this.deepEqual(q,s))))) {
            this.setState({ content: [] })
        }
        if(query.$limit){
            query.$limit = Number(query.$limit);
        }
        if (query) {
            this.setState({ query: query });
            dispatch.app.setTableFilterQuery(query)
        }

        this.setAllBasecategory(query)

        setTimeout(async () => {
            let payload = {
                query: this.state.query ? this.state.query : this.props.tableFilterQuery,
                params: { dataType: this.props.dataType }
            };
            await dispatch.content.getContentListData(payload)
            //await dispatch.content.bulkOperationIds(payload)
        }, 100);
    };
    deepEqual = (obj1, obj2) => {
        if (typeof obj1 !== "object" || typeof obj2 !== "object") {
            return obj1 === obj2;
        }
    
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
    
        if (keys1.length !== keys2.length) {
            return false;
        }
    
        for (let key of keys1) {
            if (!this.deepEqual(obj1[key], obj2[key])) {
                return false;
            }
        }
    
        return true;
    }

    handleTableComponent = (event, item, data) => {
        event.stopPropagation()
        let payload = {
            query: this.state.query ? this.state.query : this.props.tableFilterQuery,
            params: { dataType: this.props.dataType }
        };
        if (data.key === "checkbox") {
            this.setState({ content: [] });
            setTimeout(() => {
                if (item.checked) {
                    dispatch.content.bulkOperationIds(payload)
                    this.setState({ content: this.props.selectedMultipleIds, markAll: this.props.selectedMultipleIds });
                } else {
                    dispatch.content.setMultipleIds([])
                    this.setState({ content: [], markAll: [] });
                }
            }, 500);
        } else {
            if (item.checked) {
                this.setState({
                    content: [...this.state.content, data]
                })
            } else {
                const updateContentList = this.state.content.filter(item => item._id !== data._id);
                this.setState({ content: updateContentList });
            }
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.dataType !== newProps.dataType) {
            this.setKnowledgeBank()
        }

        if (this.props.selectedMultipleIds !== newProps.selectedMultipleIds) {
            this.setState({ content: newProps.selectedMultipleIds })
        }

        if (this.props.selectedAccount !== newProps.selectedAccount || this.props.categoryList !== newProps.categoryList || this.props.routeParams !== newProps.routeParams) {
            this.setAllBasecategory();
        }
    }

    componentWillMount() {
        this.setKnowledgeBank();
        // this.setUploadedBy();
    }

    // setUploadedBy() {
    //     if (this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.length !== 0) {
    //         let user = []
    //         for (let i = 0; i < this.props.selectedAccount.users.length; i++) {
    //             let ia = this.props.selectedAccount.users[i]
    //             user.push({
    //                 key: ia.id._id,
    //                 value: ia.id.firstName + ' ' + ia.id.lastName,
    //                 content: (
    //                     <span>
    //                         <Image key={i} avatar className="w_24 h_24 scaleDown" src={ia.id.profilePic} />
    //                         {ia.id.firstName}  {ia.id.lastName}
    //                     </span>
    //                 ),
    //             })
    //         }
    //         let items = Object.assign(this.state.tableHeader); // Pull the entire tableHeader object out. Using object.assign is a good idea for objects.
    //         items[5].keyValue = user; // update the tableHeader object as needed
    //         if (this.props.dataType !== "updateCategory") {
    //             items[7].listed = false
    //         } else {
    //             items[7].listed = true
    //         }
    //         this.setState({ tableHeader }); // Put back in state

    //     }
    // }

    setKnowledgeBank() {
        let pr = this.props.categoryList &&
            this.props.categoryList.length !== 0 ?
            this.props.categoryList : [];
        pr.forEach(p => {
            delete p.children
            p.image = setCategoryImage(p.image, this.props.selectedAccount)

        })
        this.setState({
            privateCategory: pr
        })
    }

    handleChangeKB = (e, data) => {
        let KB = data.options.filter((kb, i) => { return kb.value.toString() === data.value.toString() });
        KB[0].nodes && KB[0].nodes.forEach(cat => {
            delete cat.children
        })
        this.setState({
            k: KB[0].key,
            c: null,
            s: null,
            otherSubCategory: false,
            KBCategories: KB[0].nodes,
            KBSubCategories: null
        })
    }

    handleChangeCategory = (e, data) => {
        let CAT = data.options.filter((cat, i) => { return cat.value.toString() === data.value.toString() });
        if (!CAT[0].nodes) {
            CAT[0].nodes = []
        }
        // CAT[0].nodes.push({
        //     _id: "Others",
        //     name: "Others",
        //     key: "Others",
        //     text: "Others",
        //     value: "Others"
        // })
        CAT[0].nodes && CAT[0].nodes.forEach(subcat => {
            delete subcat.children
        })
        this.setState({
            c: CAT[0].key,
            s: null,
            otherSubCategory: false,
            KBSubCategories: CAT[0].nodes
        })
    }

    handleChangeSubCategory = (e, data) => {

        let SCAT = data.options.filter((sc, i) => { return sc.value.toString() === data.value.toString() });
        this.setState({
            otherSubCategory: false,
            s: SCAT[0].key,
            autoFocus: false
        })

        // if (data.value === "Others") {
        //     this.setState({
        //         otherSubCategory: true,
        //         s: '',
        //         autoFocus: true
        //     })
        // } else {
        //     this.setState({
        //         otherSubCategory: false,
        //         s: SCAT[0].key,
        //         autoFocus: false
        //     })
        // }
    }


    handleChangeSubCategoryText = (e, data) => {
        this.setState({
            s: data.value
        })
    }

    // clearSubCategory = () => {
    //     this.setState({
    //         otherSubCategory: false,
    //         s: ''
    //     })
    // }
    async componentDidMount() {
        setTimeout(() => {
            this.setState({ showLoading: false });
        }, 4000);
    }
    render() {
        const { contentListData, dataType } = this.props
        const { content, privateCategory, enabledOperation,totalRecords } = this.state
        if (contentListData && contentListData.data) {
            for (let j = 0; j < contentListData.data.length; j++) {
                contentListData.data[j].publishMe = false
                if (content) {
                    for (let i = 0; i < content.length; i++) {
                        if (content[i]._id === contentListData.data[j]._id) {
                            contentListData.data[j].publishMe = true
                        }
                    }
                }
            }
        }

        let updateHeader = dataType === "updateCategory" ? <React.Fragment>
            <label className="f_bold">Select Content to be bulk update</label>
            <p>We will update Knowledge bank, Category and Sub-category of selected content as per above categories. </p>
        </React.Fragment> : null

        let table =
            <span>
                {updateHeader}
                <CommonTable
                    tableHeader={this.state.tableHeader}
                    listData={contentListData.data}
                    limit={this.state._limit}
                    sort={this.state._sort}
                    selection={true}
                    totalCount={contentListData.total}
                    onQueryChange={this.onQueryChange}
                    handleTableComponent={this.handleTableComponent}
                    routeParams={this.props.routeParams}
                    onChangeLimit={this.onChangeLimit}
                    addColumn={this.addColumn}
                    filterHeader={true}
                    defaultMarkAll={contentListData && totalRecords && content && content.length > 0 && contentListData.total > 0 && content.length === totalRecords ? true : false}
                />
            </span>


        let emptyContentArray = (content && content.length === 0) || !enabledOperation ? true : false;
        let checkCategoryAndContent = (content && content.length === 0) || (this.state.s === null || this.state.s === '') || !enabledOperation ? true : false


        let isDisabledSubmit = (dataType === "publishAll" || dataType === "deleteAll") ? emptyContentArray :
            dataType === "updateCategory" ? checkCategoryAndContent : false;
        
        //  Loader will apear while fetching content list 
        let loadingCategory =!this.props.loadingGetContentListData && this.state.showLoading? (
            <LoadingComponent active={true} message="Fetching data..." /> ) : null;
        let loadingSpinner = this.props.loadingBulkPublish  && this.state.showLoading?
            <LoadingComponent active={true} message={`${dataType === "publishAll" ? "Publishing" : "Updating"} ${content.length} Content`} /> :
            this.props.loadingBulkDelete && this.state.showLoading ? <LoadingComponent active={true} message={`Deleting ${content.length} Content`} /> :
                null;

        const errorLabel = <div className="customErrorLabel" />;

        var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });

        let setKb = privateCategory && privateCategory.length !== 0 ?
            privateCategory.sort((a, b) => {
                return collator.compare(a.name, b.name)
            }) : null

        let bc = <React.Fragment>
            <Dropdown
                name="singleSelectWithDefaultValue"
                //value={this.state.k}
                placeholder="Select Knowledge Bank"
                fluid
                selection
                required
                validationErrors={{
                    isDefaultRequiredValue: 'You need to select a Knowledge Bank',
                }}
                errorLabel={errorLabel}
                options={setKb}
                onChange={(e, data) => { this.handleChangeKB(e, data) }}
            />
            <span>
                {this.state.KBCategories && this.state.KBCategories.length === 0 ?
                    <span className="clr-red">No Category</span> :
                    null}
            </span>
        </React.Fragment>

        let cat = <Dropdown
            name="singleSelectWithDefaultValue"
            //value={this.state.c}
            disabled={!this.state.k || (this.state.KBCategories && this.state.KBCategories.length === 0)}
            placeholder="Select Category"
            fluid
            selection
            required
            validationErrors={{
                isDefaultRequiredValue: 'You need to select a Category',
            }}
            errorLabel={errorLabel}
            options={this.state.KBCategories}
            onChange={(e, value) => { this.handleChangeCategory(e, value) }}
        />

        let sc = <React.Fragment>
            {(this.state.KBSubCategories && this.state.KBSubCategories.length === 0) ?
                <p style={{marginTop: "10px", color: "red"}}>No Sub Category available</p>:
                <Dropdown
                    name="singleSelectWithDefaultValue"
                    placeholder="Select Sub Category"
                    //value={this.state.s}
                    disabled={!this.state.c}
                    fluid
                    selection
                    required
                    validationErrors={{
                        isDefaultRequiredValue: 'You need to select a Sub Category',
                    }}
                    errorLabel={errorLabel}
                    options={this.state.KBSubCategories}
                    onChange={(e, value) => { this.handleChangeSubCategory(e, value) }}
                />}
        </React.Fragment>


        let updateCategoryComponent =
            <Form className="formcyForm" >
                <Card className="bg-light-blue w_100 " style={{ margin: "0 0 20px 0" }}>
                    <Card.Header className="pad_10">Select Content and assign categories</Card.Header>
                    <Card.Content className="pad_0">
                        <Grid columns="equal" >
                            <Grid.Row>
                                <Grid.Column >
                                    <div style={{ margin: "0 0 5px 0px" }} > Knowledge Bank <span className="clr-red" >*</span> </div>
                                    {bc}
                                </Grid.Column>
                                <Grid.Column>
                                    <div style={{ margin: "0 0 5px 0px" }}> Category <span className="clr-red" >*</span> </div>
                                    {cat}
                                </Grid.Column>
                                <Grid.Column >
                                    <div style={{ margin: "0 0 5px 0px" }}> Sub Category <span className="clr-red" >*</span> </div>
                                    {sc}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Card.Content>
                </Card>
            </Form>


        return (
            <Modal
                open={this.props.publishAllOpen}
                onClose={this.handleClose}
                size='large'
                className="basicModal"
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                <Modal.Header>
                    {dataType === "publishAll" ? "Publish Content" : null}
                    {dataType === "deleteAll" ? "Delete Content" : null}
                    {dataType === "updateCategory" ? "Change Category" : null}
                </Modal.Header>
                <Divider style={{ margin: "10px 0 0px" }} />

                {/* {this.state.noRecordAvailable ?
                    <NothingToShow /> : */}
                <React.Fragment>
                    <Modal.Content scrolling style={{height: "410px"}}>
                        {loadingSpinner}
                        {loadingCategory}
                        {this.props.dataType === "updateCategory" ?
                            updateCategoryComponent : null}
                        {table}
                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                        <Message
                            className="float-left"
                            style={{
                                display: "inline-flex",
                                width: "calc(100% - 260px)",
                                textAlign: "left"
                            }} >
                            <Checkbox
                                onChange={(e, data) => this.enableBulkOperation(e, data)} /> &nbsp; &nbsp;

                        {dataType === "publishAll" ?
                                <Message.Content>
                                    <Message.Header>Confirm Bulk Publish</Message.Header>
                                Selected content will be bulk published in the Workspace Library.
                        </Message.Content>
                                : null}
                        {dataType === "deleteAll" ?
                                <Message.Content>
                                    <Message.Header>Confirm Bulk Delete</Message.Header>
                                Selected content will be deleted.
                        </Message.Content>
                                : null}
                            {/* {dataType === "deleteAll" ? "" : null} */}
                            {dataType === "updateCategory" ?
                                <Message.Content>
                                    <Message.Header>Confirm Bulk Update</Message.Header>
                                Selected content will be bulk updated with respect to knowledge bank, category and subcategory.
                        </Message.Content> : null}
                        </Message>
                        <Button as='div' labelPosition='right'
                            id='publishAllSubmit'
                            disabled={isDisabledSubmit}
                            className="button-submit float-right"
                            onClick={this.handleSubmit}
                            dataType={dataType}>
                            <Button className={`
                        ${dataType === "publishAll" ? "button-submit" : null}
                        ${dataType === "deleteAll" ? "button-warning " : null}
                        ${dataType === "updateCategory" ? "button-submit" : null}
                        `}>
                                {dataType === "publishAll" ? "Publish" : null}
                                {dataType === "deleteAll" ? "Delete " : null}
                                {dataType === "updateCategory" ? "Update" : null}
                            </Button>
                            <Label as='a' basic className="clr-blue" pointing='left'>
                                {content && content.length}
                            </Label>
                        </Button>
                        <Button
                            id='publishAllCancel'
                            className="button-cancel"
                            onClick={this.handleClose}
                        > Cancel </Button>
                    </Modal.Actions>
                </React.Fragment>
                {/* } */}
            </Modal >
        )
    }
}

export default PublishAllContentModal;